import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LiumexAuthGuard } from 'src/services/liumex-auth.guard';
import { SettingsComponent } from './settings/settings.component';
import { HomeComponent } from './home/home.component';
import { CompetitionCreateComponent } from './competition-create/competition-create.component';
import { CompetitionEditComponent } from './competition-edit/competition-edit.component';
import { StageComponent } from './stage/stage.component';
import { TeamCreateComponent } from './team-create/team-create.component';
import { TeamEditComponent } from './team-edit/team-edit.component';
import { BadgeMealCounterComponent } from './badge-meal-counter/badge-meal-counter.component';
import { BadgeRegistryComponent } from './badge-registry/badge-registry.component';
import { BadgeMealCounterExternalComponent } from './badge-meal-counter-external/badge-meal-counter-external.component';
import { StageScheduleComponent } from './stage-schedule/stage-schedule.component';
import { VetoComponent } from './veto/veto.component';
import { VetoCreateComponent } from './veto-create/veto-create.component';
import { VetoListComponent } from './veto-list/veto-list.component';
import { VetoSettingsComponent } from './veto-settings/veto-settings.component';
import { RefereePanelComponent } from './referee-panel/referee-panel.component';

const routes: Routes = [
  {
    path: 'veto',
    component: VetoComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/dashboard',
    component: DashboardComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/stage',
    component: StageComponent, 
    canActivate: [LiumexAuthGuard],
    data: { hideHeaderAndFooter: true }
  },
  {
    path: ':workspaceId/referee',
    component: RefereePanelComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/s/schedule',
    component: StageScheduleComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/v/create',
    component: VetoCreateComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/v/list',
    component: VetoListComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/v/settings',
    component: VetoSettingsComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/c/create',
    component: CompetitionCreateComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/c/:competitionId',
    component: CompetitionEditComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/t/create',
    component: TeamCreateComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/t/:competitionId',
    component: TeamEditComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/b/registry',
    component: BadgeRegistryComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/b/meal-counter',
    component: BadgeMealCounterComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/external/meal-counter',
    component: BadgeMealCounterExternalComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: ':workspaceId/settings',
    component: SettingsComponent, 
    canActivate: [LiumexAuthGuard],
  },
  {
    path: '',
    component: HomeComponent, 
    canActivate: [LiumexAuthGuard],
  },
];

export const authNeeded = [
  "/dashboard", "/s/", "/v/", "/c/", "/t/", "/b/", "/settings"
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
